export var VIEW_LAYER_LIFE_CYCLE;
(function (VIEW_LAYER_LIFE_CYCLE) {
    VIEW_LAYER_LIFE_CYCLE["BEFORE_INIT"] = "beforeinit";
    VIEW_LAYER_LIFE_CYCLE["AFTER_INIT"] = "afterinit";
    VIEW_LAYER_LIFE_CYCLE["BEFORE_RENDER"] = "beforerender";
    VIEW_LAYER_LIFE_CYCLE["AFTER_RENDER"] = "afterrender";
    VIEW_LAYER_LIFE_CYCLE["BEFORE_CHANGE_DATA"] = "beforechangedata";
    VIEW_LAYER_LIFE_CYCLE["AFTER_CHANGE_DATA"] = "afterchangedata";
})(VIEW_LAYER_LIFE_CYCLE || (VIEW_LAYER_LIFE_CYCLE = {}));
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/base/constants.js
// module id = null
// module chunks = 